export default "__VITE_ASSET__DoE$GM7G__"